import type { FC } from "react";
import React from "react";

import cn from "classnames";

import classes from "./AvatarStub.styl";

export interface IAvatarStubProps {
    type: "profile" | "group";
}

const AVATAR_STUB_TEST_ID = "avatar-stub-test-id";

export const AvatarStub: FC<IAvatarStubProps> = ({ type }) => {
    return (
        <div
            data-tsid={AVATAR_STUB_TEST_ID}
            className={cn(classes["stub"], {
                [classes["__profile"]]: type === "profile",
                [classes["__group"]]: type === "group",
            })}
        />
    );
};

AvatarStub.displayName = "Avatar.Stub";

export default AvatarStub;
